/*
 * vaporizer-prescription (schema)
 */
import { boolean, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"
import { users } from "../user/user.schema"

export const vaporizerPrescriptions = schema.table("vaporizer_prescriptions", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),
	practitionerId: uuid("practitioner_id").references(() => practitioners.id, {
		onDelete: "set null",
	}),

	// --- Prescription ---
	prescriptionDate: timestamp("prescription_date", { withTimezone: true }).notNull().defaultNow(),
	expiryDate: timestamp("expiry_date", { withTimezone: true }),
	notes: text("notes"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
